import React from 'react';
import {BaseIconProps} from '../../types';

export const BaseFavourite: React.FC<BaseIconProps> = ({color, size}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C12.6511 2 13.2278 2.41997 13.4276 3.03959L15.1018 8.23077L20.5562 8.21885C21.2073 8.21743 21.7849 8.63614 21.9861 9.25532C22.1873 9.87451 21.9661 10.5528 21.4385 10.9343L17.0188 14.1307L18.7156 19.3145C18.9182 19.9333 18.6985 20.612 18.1717 20.9947C17.645 21.3774 16.9316 21.3766 16.4057 20.9927L12 17.7771L7.59426 20.9927C7.06839 21.3766 6.35497 21.3774 5.82826 20.9947C5.30155 20.612 5.08183 19.9333 5.28437 19.3145L6.98123 14.1307L2.56147 10.9343C2.03393 10.5528 1.81273 9.87451 2.01391 9.25532C2.2151 8.63614 2.79273 8.21743 3.44377 8.21885L8.89823 8.23077L10.5724 3.03959C10.7722 2.41997 11.349 2 12 2ZM9.98978 9.73316L3.4405 9.71885L8.74739 13.5568L6.70994 19.7812L12 15.92L17.2901 19.7812L15.2526 13.5568L20.5595 9.71885L14.0102 9.73316L12 3.5L9.98978 9.73316Z"
        fill={color}
      />
    </svg>
  );
};
